import {Injectable} from '@angular/core';
import {FilterControl} from '../interface/filter-control';
import {FabricFilterResultService} from './fabric-filter-result.service';
import {FabricPreparationService} from './fabric-preparation.service';
import {ProductListing} from 'src/app/raintree/interface/product-listing/product-listing';
import {Subject} from 'rxjs';
import {ActivatedRoute} from "@angular/router";
import {FilterUrlDecoderService} from "./filter-url-decoder.service";
import {UntilDestroy} from "@ngneat/until-destroy";

@UntilDestroy()
@Injectable({
	providedIn: 'root'
})
export class FabricFilterService {
	public filteredData: Subject<ProductListing[]> = new Subject<ProductListing[]>()
	public filteredWithoutPrice: ProductListing[] = [];
	private filterList: string[] = [ //TODO: filter order restructuring for custom filter placement
		'product-category',
		'crafts',
		'category',
		'material',
		'pattern',
		'gsm',
		'quantity',
		'instock',
		'colour',
		'price',
	];

	constructor(
		private _prepService: FabricPreparationService,
		private _resultService: FabricFilterResultService,
		private _activatedRoute: ActivatedRoute,
		private _urlDecodeAndChangeFilter: FilterUrlDecoderService
	) {
	}

	public prepareFilterControls(
		previews: ProductListing[]
	): FilterControl {

		return this.prepareFabricFiltersFromData(previews)
	}

	public prepareFilterResults(
		controls: FilterControl,
		previews: ProductListing[]
	): ProductListing[] {
		// debugger
		let result: ProductListing[] = [...previews];

		controls.normalFilterControls.forEach(control => {
			if (control.name == 'patterns') {
				result = this._resultService.getFilteredResultForCommonFilter(result, control.options, 'patterns');
			}
			if (control.name == 'materials') {
				result = this._resultService.getFilteredResultForCommonFilter(result, control.options, 'materials');
			}
			// debugger
			if (control.name == 'category') {
				result = this._resultService.getFilteredResultForCommonFilterForCategory(result, control.options, 'category');
			}
		});

		controls.colorFilterControls.forEach(control => {
			result = this._resultService.getFilteredResultForCommonFilter(result, control.options, 'colors');
		});

		// controls.nestedControls.forEach(control => {
		// 	result = this._resultService.filterResultForNestedFilter(result, control, 'subCategory');
		// });

		result = this._resultService.filterResultForNestedFilter(result, controls.nestedControls, 'subCategory');

		// debugger
		// console.log(result);
		this.filteredWithoutPrice = [...result];

		controls.rangeFilterControls.forEach(control => {
			if (control.values.max) {
				if (control.key == 'price') {
					result = this._resultService.getFilteredResultByRange(
						result,
						control.key,
						control.values.value1,
						control.values.value2,
						['price'].includes(control.key)
					)
				}

				if (control.key == 'quantity') {
					result = this._resultService.getFilteredResultByRange(
						result,
						control.key,
						control.values.value1,
						control.values.value2,
						['quantity'].includes(control.key)
					)
				}
				if (control.key == 'gsm') {
					result = this._resultService.getFilteredResultByRange(
						result,
						control.key,
						control.values.value1,
						control.values.value2,
						['gsm'].includes(control.key)
					)
				}

				// if (control.key == 'gsm') {
				// 	debugger
				// 	result = this._resultService.getFilteredResultByRange(
				// 		result,
				// 		control.key,
				// 		control.values.value1,
				// 		control.values.value2,
				// 		['gsm'].includes(control.key)
				// 	)
				// }

			}
		});

		controls.singleFilterControls.forEach(control => {
			result = this._resultService.getSingleFilteredResult(result, control);
		});

		// console.log(result);
		this.filteredData.next(result);
		return result;

	}

	private prepareFabricFiltersFromData(
		previews: ProductListing[]
	): FilterControl {

		let controls: FilterControl = {
			nestedControls: [],
			normalFilterControls: [],
			colorFilterControls: [],
			rangeFilterControls: [],
			singleFilterControls: []
		};

		this.filterList.forEach(filter => {
			// TODO: include crafts later
			switch (filter) {

				case 'product-category':
					controls.nestedControls = this._prepService.getNestedFilterItems(previews)
					break;


				case 'category':
					controls.normalFilterControls.push({
						name: 'category',
						options: this._prepService.getUniqueFilterItems('category', previews)
					});
					break;


				case 'material':
					controls.normalFilterControls.push({
						name: 'materials',
						options: this._prepService.getUniqueFilterItems('materials', previews)
					});
					break;

				case 'pattern':
					controls.normalFilterControls.push({
						name: 'patterns',
						options: this._prepService.getUniqueFilterItems('patterns', previews)
					});
					break;

				case 'colour':
					controls.colorFilterControls.push({
						name: 'Colours',
						options: this._prepService.getColorFilterItems('colors', previews)
					});
					break;

				case 'gsm':
					controls.rangeFilterControls.push({
						name: 'GSM',
						key: 'gsm',
						values: this._prepService.getRangeFilterItems('gsm', previews, false)
					});
					break;

				case 'price':

					controls.rangeFilterControls.push({
						name: 'Price',
						key: 'price',
						values: this._prepService.getRangeFilterItems('price', previews, true)
					});

					break;

				case 'quantity':
					// debugger
					controls.rangeFilterControls.push({
						name: 'Availability',
						key: 'quantity',
						values: this._prepService.getRangeFilterItems('quantity', previews, true)
					});

					break;

				case 'instock':
					// debugger
					controls.singleFilterControls.push({
						name: 'Instock',
						options: this._prepService.getAvailabilityControls(previews),
					});
					break;
			}
		});

		// TODO: onload handle
		// TODO: Decode url and prepare controls
		// TODO: make a seekFilterChanges func and call prepareFilterResults with arg: previews
		// TODO: set product listing array named (filteredData) observable


		let hasUrlParam: boolean = !!Object.entries(this._activatedRoute.snapshot.queryParams).length;
		if (hasUrlParam && previews.length > 0) {
			controls = this._urlDecodeAndChangeFilter.decodeUrlAndChangeFilter(controls)
		}

		this.prepareFilterResults(
			controls,
			previews
		);


		// TODO: do not remove start
		// this._activatedRoute.queryParams.subscribe((p:Params): void => {
		//
		// 	let hasUrlParam:boolean = !!Object.entries(this._activatedRoute.snapshot.queryParams).length;
		// 	if(hasUrlParam && previews.length>0){
		// 		controls = this._urlDecodeAndChangeFilter.decodeUrlAndChangeFilter(controls)
		// 	}
		//
		// 	this.prepareFilterResults(
		// 		controls,
		// 		previews
		// 	);
		// });
		// TODO: do not remove end

		//


		return controls;
	}


}
